import { render, staticRenderFns } from "./page-list.vue?vue&type=template&id=7d060a81"
import script from "./page-list.vue?vue&type=script&lang=js"
export * from "./page-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports